
import { useRoute } from 'vue-router'
import { toRefs, defineComponent, reactive, getCurrentInstance, computed } from 'vue'
import { store, useStore } from '@/store/index'
import Keys from '@/constant/key'
import { Plus, Delete, UploadFilled } from '@element-plus/icons-vue'
import { saveContentApi, getQualificationListApi, getInfoByIdCardApi } from '@/apis/qualification'
import { CheckType } from '@/enums/qualification'
import { getFileSuffix } from '../../utils/index'
import { isValidIdCard } from '../../utils/validator'
import RegionPicker from '@/components/RegionPicker.vue'
import { fileUpload } from '@/utils/upload'
import { areaList } from '@/utils/area'
import { UserMutationTypes } from '@/store/modules/user/mutation-types'

export default defineComponent({
name: 'QualificationEdit',
components: { Plus, Delete, UploadFilled, RegionPicker },

setup () {
    const { proxy } = getCurrentInstance() as any
    const route = useRoute()
    const store = useStore()

    // @ts-ignore
    const isMerchant = store.state.user.userInfo.user_type == 2 // 判断当前用户是否为商户
    const is_contracts = computed(() => {
        return store.state.user.is_contracts as number
    }) // 商户法人信息完善提示弹框

    const businessFormDisabled = computed(() => {
        return state.businessFormData.status == '0' || (state.listType == 1 && state.hasCheckLog)
    }) // 商户法人信息完善提示弹框
    // 验证身份证号是否有效
    const checkIdNumber = (rule:any, val:any, callback:any) => {
        isValidIdCard(val) ? callback() : callback(new Error('请输入正确的身份证号'))
    }

    const state = reactive({
        brandId:        route.query.brand_id || store.state.user.userInfo.brandArr[0].id || '',     // 当前操作品牌 id
        brandName:      route.query.brand_name || store.state.user.userInfo.brandArr[0].name || '',   // 当前操作品牌名称
        status:         1,          // 当前查询状态

        activeIndex:    '1',        // 当前操作 tab 索引
        dialogVisible:  false,      // 是否显示弹框
        fileList:       <any>[],    // 回显图片列表
        previewList:    [],         // 预览图片
        imgUrls:        [],         // 上传至后台的图片地址（不包含域名）
        tableData:      <any>[],    // 表格显示数据
        validDate:      '',         // 过期时间
        msgStatus:      true,       // 过期提醒开通状态
        uploadUrl:      '',         // 上传图片地址
        labelId:        '',         // 当前操作标签 id
        labelName:      '',         // 当前操作标签名称
        moldId:         '',         // 当前操作模板 id
        moldName:       '',         // 当前操作模板名称
        productId:      '',         // 当前选中商品 id
        productList:    <any>[],    // 商品列表
        currentPage:    1,      
        pageSize:       10,
        total:          0,
        listType:       1,          // 商户端列表类型：1-资质列表，2-审核记录
        rejectMsg:      '',         // 商户端列表：驳回原因

        // 营业执照专用表单
        businessDialogVisible: false,   // 营业执照&法人信息弹框
        businessFormData: {
            id_name:        '',         // 法人姓名
            id_number:      '',         // 法人身份证号
            id_photo:       '',         // 法人身份证：正反图片以 , 分隔
            province_code:  '',         // 省份编码
            province:       '',         // 省份名称
            city_code:      '',         // 城市编码
            city:           '',         // 城市名称
            registered_address: '',     // 地址详情
            business_license:   '',     // 营业执照
            end_time:       '',         // 有效期
            long_time:'',         // 是否长期有效
            status:         '',         // 审核状态
            msg:            '',         // 驳回原因

            selectRegion:   {},         // 已选择地区
            idCard1:        '',         // 身份证人像面
            idCard2:        '',         // 身份证国徽面
        },

        businessRules: {
            id_name: [{ required: true, message: '请输入法人姓名', trigger: 'blur' }],
            id_number: [
                { required: true, message: '请输入法人身份证号', trigger: 'blur' },
                { validator: checkIdNumber, trigger: 'blur' }
            ],
            idCard1: [{ required: true, message: '请上传法人身份证头像面', trigger: 'change' }],
            idCard2: [{ required: true, message: '请上传法人身份证国徽面', trigger: 'change' }], 
            selectRegion: [{ required: true, message: '请选择省市', trigger: 'change' }],
            id_photo: [{ required: true, message: '请上传法人身份证', trigger: 'change' }],
            registered_address: [
                { required: true, message: '请输入地址详情', trigger: 'blur' },
                { required: true, message: '请输入地址详情', trigger: 'change' }
            ],
            business_license: [{ required: true, message: '请上传营业执照', trigger: 'change' }],
            end_time: [{ required: true, message: '请选择有效期', trigger: 'change' }],
        },
        disabledStartDate (date) { // 返回开始不可用日期
            return (date.getTime()) <= Date.now()
        },
        // 商户端切换列表类型
        onTabChange () {
            state.getMoldList()
        },
        // 类型切换
        onNavChange (index:string) {
            state.activeIndex = index
            if (index === '3') {
                state.getProductList()
            }
            state.currentPage = 1
            state.total = 0
            state.getMoldList()
        },
        // 标红过期行
        rowClassName (row, rowIndex) {
            return row.row.is_stale_dated==1 ? 'danger-row' : ''
        },
        /**
         * 编辑
         * showRejectDialog：由首页完善弹框跳转过来，且存在驳回数据，展示驳回数据弹框重新提交
        */
        hasCheckLog: false, // 当时记录是否存在正在审核中的记录
        onEdit (rowData, showRejectDialog = 0) {
            state.hasCheckLog = rowData.check_status === 0
            proxy.setActive(rowData)
            proxy.getMsg(showRejectDialog)
        },
        // 当营业执照选择长期时清空已选过期时间
        onLongTimeChange (val) {
            if (val == 1) {
                state.businessFormData.end_time = ''
            }
        },
        // 删除记录
        onDel (rowData) {
            let id  = rowData.id
            proxy.$confirm('确定要删除该标签及下属所有相关资料？', '提示').then(() => {
                proxy.$http.post('/cake/delLabel', {id}).then(res => {
                    if (res.code == 200) {
                        proxy.$message({
                            type: 'success',
                            message: '删除成功'
                        })
                        state.getMoldList()
                    } else {
                        proxy.$message({
                            type: 'error',
                            message: res.msg
                        })
                    }
                })
            }).catch(() => {
                proxy.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        // 添加新标签
        onAddLabel () {
            let activeIndex = state.activeIndex
            let productList = state.productList
            let productId = state.productId
            let name = ''

            if (activeIndex==='2') {
                name = state.labelName
                if (!name) {
                    return proxy.$message({
                        type: 'error',
                        message: '请填写模板名称'
                    })
                }
            }
            if (activeIndex==='3') {
                if (!productId) {
                    return proxy.$message({
                        type: 'error',
                        message: '请选择商品'
                    })
                }
                name = productList.find((item)=>{return item.id === productId}).title
            }
            proxy.$http.post('/cake/setLabel', {
                tab_type: activeIndex,
                brand_id: state.brandId,
                name,
                product_id: productId
            }).then(res => {
                if (res.code == 200) {
                    proxy.$message({
                        type: 'success',
                        message: '添加成功'
                    })
                    state.getMoldList()
                } else {
                    proxy.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
        },
        // 图片验证
        onBeforeUpload (file) {
            const types = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf']
            if (!types.includes(file.type)) {
                proxy.$message({
                    type: 'error',
                    message: '仅支持上传 PNG，JPG，JPEG, PDF 格式的图片'
                })
                return false
            }
            if (file.size > 1024 * 1024 * 10) {
                proxy.$message({
                    type: 'error',
                    message: '图片须小于 10 M'
                })
                return false
            }
        },
        // 图片上传成功回调
        uploadSuccess (res:any) {
            const { code, data:resData, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

            // 商户端先暂存图片，点击保存时再同时上传；商务端直接重新获取最新数据
            if (isMerchant) {
                // @ts-ignore
                state.previewList.push(resData.img_url)
                // @ts-ignore
                state.imgUrls.push(resData.img_urls)
                state.fileList.push({
                    name: Date.now(),
                    url: resData.img_url
                })
            } else {
                // @ts-ignore
                state.previewList.push(resData)
                // @ts-ignore
                state.fileList.push({
                    name: Date.now(),
                    url: resData
                })
            }
        },
        onUploadSuccess: async (param:any, type:number) => {
            const { code, data, msg } = await fileUpload(param.file, {folderName: 'scene'}) as any
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

            const { url } = data

            if (type === 1) { // 身份证人像面
                state.businessFormData.idCard1 = url
                state.getIdCartInfo(url) // 身份证人像面，根据图片获取户籍信息并填充至户籍栏
            } else if (type === 2) { // 身份证国徽面
                state.businessFormData.idCard2 = url
            } else { // 营业执照
                state.businessFormData.business_license = url
            }
        },
        getIdCartInfo: async (url: string) => {
            const { code, data, msg } = await getInfoByIdCardApi(url, 'IdCard') as any

            if (code!= 200) { return proxy.$message({ type: 'error', message: msg }) }
            state.businessFormData.registered_address = data.address
        },
        // 删除身份证图片
        onRemoveCard (type: number) {
            if (type === 1) {
                state.businessFormData.idCard1 = ''
            } else if (type === 2) {
                state.businessFormData.idCard2 = ''
            } else {
                state.businessFormData.business_license = ''
            }
        },
        // 删除图片
        onRemove (index, item) {
            let id = state.fileList[index].name
            if (id) {
                proxy.$confirm(`${ isMerchant ? '删除图片需要重新提交审核，通过后会自动生效。确定要删除该图片？' : '确定要删除该图片？' }`, '提示').then(() => {
                    let idx = state.previewList.findIndex(img => img == item)
                    state.previewList.splice(idx, 1)
                    state.imgUrls.splice(index, 1)
                    
                    // /**
                    //  * 商户端删除只删除本地
                    //  * 商务端删除直接删除远程数据
                    // */
                    // if (isMerchant) {
                    //     let idx = state.previewList.findIndex(img => img == item)
                    //     state.previewList.splice(idx, 1)
                    //     state.imgUrls.splice(index, 1)
                    // } else {
                    //     proxy.$http.get(`/cake/del_oss_img?img_id=${id}&admin_uid=${store.state.user.userInfo.id}`).then(res => {
                    //         if (res.code == 200) {
                    //             proxy.$message({
                    //                 type: 'success',
                    //                 message: '删除成功'
                    //             })
                    //             proxy.getMsg()
                    //             proxy.getMoldList()
                    //         } else {
                    //             proxy.$message({
                    //                 type: 'error',
                    //                 message: res.msg
                    //             })
                    //         }
                    //     })
                    // }
                }).catch(() => {
                    proxy.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
            }
        },
        // 打包下载
        onDownload (rowData) {
            proxy.setActive(rowData)
            let url = `/cake/downloadImg?brand_id=${state.brandId}&brand_name=${state.brandName}_${state.labelName}_${state.moldName}&mold_id=${state.moldId}&contracts_id=${state.labelId}`
            proxy.$http.get(url).then(res => {
                if (res.code == 12200) {
                    proxy.$message({
                        type: 'warning',
                        message: '当前没有可下载图片'
                    })
                } else {
                    window.open(Keys.baseUrl + url)
                }
            })
        },
        // 保存
        onSaveMsg: async () => {
            const { brandId, moldId, labelId, validDate, msgStatus, previewList, imgUrls } = state
            let postData:any = {}
            // 非商户时：资质图片和有效期可以同时不传，但其中一个有值另一个就必选
            if (!isMerchant && moldId != '5') {
                const hasImg = previewList.length > 0
                const hasDate = !!validDate
                if (hasImg && !hasDate) {
                    return proxy.$message({ type: 'error', message: '已上传资质图片，请选择过期时间' })
                }
                if (!hasImg && hasDate) {
                    return proxy.$message({ type: 'error', message: '已选择过期时间，请上传资质图片' })
                }
            } else if (isMerchant) {
                if (moldId != '5' && !validDate) {
                    return proxy.$message({ type: 'error', message: '请选择过期时间' })
                }
                if (moldId != '5' && previewList.length == 0) return proxy.$message({ type: 'error', message: '请上传资质图片' })
            }
            postData.brand_id = brandId
            postData.mold_id = moldId
            postData.end_time = validDate
            if (isMerchant) {
                let imgUrlsStr = ''
                imgUrls.map((item:any) => {
                    let str = item.indexOf('?') == -1 ? item : item.substring(0, item.indexOf('?'))
                    imgUrlsStr += str + ','
                })
                postData.img_urls = imgUrlsStr.substring(0, imgUrlsStr.length - 1)
            } else {
                postData.img_url = state.previewList.join(',')
                postData.contracts_id = labelId
                postData.msg_status = msgStatus ? 'on': 'off'
                postData.admin_uid = store.state.user.userInfo.id
            }

            // if (isMerchant) {
            //     if (moldId != '5' && previewList.length == 0) return proxy.$message({ type: 'error', message: '请上传资质图片' })
            //     let imgUrlsStr = ''
            //     imgUrls.map((item:any) => {
            //         let str = item.indexOf('?') == -1 ? item : item.substring(0, item.indexOf('?'))
            //         imgUrlsStr += str + ','
            //     })
            //     postData.img_urls = imgUrlsStr.substring(0, imgUrlsStr.length - 1)
            // } else {
            //     postData.contracts_id = labelId
            //     postData.msg_status = msgStatus ? 'on': 'off'
            //     postData.admin_uid = store.state.user.userInfo.id
            // }

            let validResult = true
            if (moldId == '5') {
                postData = {
                    ...postData,
                    ...state.businessFormData
                }
                postData.province_code = postData.selectRegion.province
                postData.province = areaList.province_list[postData.selectRegion.province]
                postData.city_code = postData.selectRegion.city
                postData.city = areaList.city_list[postData.selectRegion.city]
                postData.id_photo = postData.idCard1 + ',' + postData.idCard2
                validResult = await proxy.$refs['businessForm'].validate()
                if (!state.businessFormData.long_time && !state.businessFormData.end_time) {
                    validResult = false
                    return proxy.$message({ type: 'error', message: '请选择过期时间' })
                }
            }

            if (!validResult) return
            saveContentApi(postData).then((res:any) => {
                const { code, data, msg } = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                
                proxy.$message({ type: 'success', message: '保存成功' })
                state.getMoldList()
                proxy.dialogVisible = false
                proxy.businessDialogVisible = false
                
                store.commit(UserMutationTypes.SET_IS_CONTRACTS, 1)
            })
        },
        // 显示当前行数据
        onShowRow (rowData) {
            state.rejectMsg = rowData.msg
            if (rowData.mold_id == '5') {
                rowData.idCard1 = rowData.id_photo?.split(',')[0]
                rowData.idCard2 = rowData.id_photo?.split(',')[1]
                rowData.selectRegion = {
                    province: rowData.province_code,
                    city: rowData.city_code
                }

                Object.assign(state.businessFormData, rowData)
                state.businessDialogVisible = true
            } else {
                state.previewList = rowData.img_url
                state.dialogVisible = true
            }
        },
        // 设置当前操作数据
        setActive (rowData) {
            if (state.activeIndex === '1') {
                state.moldId = rowData.id
            } else {
                let tmpArr = rowData.id.split('_')
                state.labelId = tmpArr[0]
                state.moldId = tmpArr[1]
                state.labelName = rowData.parent_name
            }
            state.moldName = rowData.name
        },
        // 获取模板列表
        async getMoldList () {
            const { brandId, labelId, moldId, listType, activeIndex, currentPage, productId } = state
            let params:any = {}
            params.brand_id = brandId

            if (isMerchant) {
                params.listType = listType
            } else {
                params.tab_type = activeIndex
                params.page = currentPage
                params.product_id = productId
            }
            const { code, data:rtData, msg } = await getQualificationListApi(params) as any
            
            if (state.activeIndex === '1' || isMerchant) {
                state.tableData = rtData
                if (route.query.incomplete && (is_contracts.value == 2 || is_contracts.value == 3)) {
                    let rowData = rtData.find(item => item.id == 5)
                    state.onEdit(rowData, 1)
                }
            } else {
                let resData = rtData.data
                // 重组二级模板的 id：解决渲染时 id 重复和问题和获取二级模板 id 时无法获取父元素 id 的问题。
                resData.forEach(item => {
                    if (item.children.length) {
                        item.children.forEach(subItem => {
                            subItem.id = item.id + '_' + subItem.id
                            subItem.parent_name = item.name
                        })
                    }
                });
                state.tableData = resData
                state.total = rtData.total
            }
        },
        // 获取商品列表
        getProductList () {
            proxy.$http.get(`/cake/product_list?brand_id=${state.brandId}`).then(res => {
                if (res.code == 200) {
                    state.productList = res.data
                } else {
                    proxy.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
        },
        // 获取弹框图片和过期信息反显数据
        getMsg (showRejectDialog) {
            proxy.$http.get(`/cake/msgList?brand_id=${state.brandId}&contracts_id=${state.labelId}&mold_id=${state.moldId}`).then(res => {
                if (res.code == 200) {
                    let fileList = <any>[]
                    let previewList = <any>[]
                    let imgUrls = <any>[]
                    let imgInfo = res.data.img_info
                    if (imgInfo.length) {
                        imgInfo.forEach(item => {
                            fileList.push({
                                name: item.id,
                                url: `${item.img_url}?v=${Date.now()}`
                            })
                            previewList.push(`${item.img_url}?v=${Date.now()}`)
                            imgUrls.push(`${item.img_urls}?v=${Date.now()}`)
                        });
                    }
                    state.fileList = fileList
                    state.previewList = previewList
                    state.imgUrls = imgUrls
                    
                    if (showRejectDialog || res.data.msg_info) {
                        let rtData = showRejectDialog && res.data.reject_info ? res.data.reject_info : res.data.msg_info
                        if (rtData.end_time == '0000-00-00') { rtData.end_time = '' }
                        state.validDate = rtData.end_time
                        state.msgStatus = rtData.del ? false : true
                        state.businessFormData = rtData || {}
                        state.businessFormData.selectRegion = {
                            province: rtData.province_code,
                            city: rtData.city_code
                        }
                        state.businessFormData.idCard1 = rtData.id_photo?.split(',')[0]
                        state.businessFormData.idCard2 = rtData.id_photo?.split(',')[1]
                    } else {
                        state.validDate = ''
                        state.msgStatus = true
                    }
                    state.moldId == '5' ? state.businessDialogVisible = true : state.dialogVisible = true
                } else {
                    proxy.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
        },
        // 打开 PDF
        openPdf (item) {
            window.location.href = item
        },
        // 翻页
        onCurrentChange (val) {
            state.currentPage = val
            state.getMoldList()
        }
    })

    // onMounted(() => {
    //     console.log(is_contracts)
    //     if (is_contracts == 2 || is_contracts == 3) {
    //         setTimeout(() => {
    //             let rowData = state.tableData.find(item => item.id == 5)
    //             state.onEdit(rowData)
    //         }, 0);
    //     }
    // })

    state.getMoldList()
    return { ...toRefs(state), isMerchant, store, CheckType, getFileSuffix, is_contracts, businessFormDisabled }
}
})
